<template>
  <v-card class="pa-4">
    <div class="text-subtitle-1 font-weight-medium mb-2">
      {{
        confirmedWarnings
          ? $t("acceptance.validation.title_confirmed")
          : $t("acceptance.validation.title")
      }}
    </div>

    <div v-if="!blocking.length && !warnings.length" class="text-body-2">
      {{
        confirmedWarnings
          ? $t("acceptance.validation.none_confirmed")
          : $t("acceptance.validation.none")
      }}
    </div>

    <template v-if="blocking.length">
      <div class="text-body-2 font-weight-medium text-red-darken-2 mb-1">
        {{ $t("acceptance.validation.blocking", { count: blocking.length }) }}
      </div>
      <div
        v-for="item in blocking"
        :key="`b-${item.code}`"
        class="acceptance-item d-flex align-start py-2"
      >
        <v-icon size="16" color="red-darken-2" class="mr-2 mt-1">
          mdi-alert-circle-outline
        </v-icon>
        <a
          href="#"
          class="text-body-2 text-red-darken-2"
          @click.prevent="$emit('select', item.code)"
        >
          {{ label(item) }}
        </a>
      </div>
    </template>

    <template v-if="warnings.length">
      <div class="text-body-2 font-weight-medium text-amber-darken-4 mt-3 mb-1">
        {{ $t("acceptance.validation.warnings", { count: warnings.length }) }}
      </div>
      <div
        v-for="item in warnings"
        :key="`w-${item.code}`"
        class="acceptance-item d-flex align-start py-2"
      >
        <v-icon size="16" color="amber-darken-4" class="mr-2 mt-1">
          mdi-alert-outline
        </v-icon>
        <a
          href="#"
          class="text-body-2 text-amber-darken-4"
          @click.prevent="$emit('select', item.code)"
        >
          {{ label(item) }}
        </a>
      </div>
    </template>

    <div v-if="!confirmedWarnings" class="text-caption text-grey-darken-1 mt-3">
      {{ $t("acceptance.validation.deadlines_note") }}
    </div>
  </v-card>
</template>

<script>
import { validationLabel } from "@/components/Acceptance/validationLabels.mjs";

export default {
  name: "AcceptanceValidationPanel",
  props: {
    // GET / PATCH `validation`: { blocking: [{ code, details? }], warnings: [...] }
    validation: { type: Object, default: null },
    // dossier.checklist, to name the lines still to answer
    lines: { type: Array, default: () => [] },
    // dossier.warningsAtConfirm (warning codes) once confirmed; null while a draft. A confirmed
    // dossier shows what was recorded at confirm, not a live preview.
    confirmedWarnings: { type: Array, default: null },
  },
  emits: ["select"],
  computed: {
    blocking() {
      if (this.confirmedWarnings) return [];
      return (this.validation && this.validation.blocking) || [];
    },
    warnings() {
      if (this.confirmedWarnings) {
        return this.confirmedWarnings.map((code) => ({ code }));
      }
      return (this.validation && this.validation.warnings) || [];
    },
  },
  methods: {
    label(item) {
      return validationLabel(item, {
        t: (key, params) => this.$t(key, params),
        lines: this.lines,
      });
    },
  },
};
</script>

<style scoped>
.acceptance-item + .acceptance-item {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
</style>
